import React from "react";
import { X, MessageCircle, Sparkles } from "lucide-react";

export default function PaymentSoonModal({ open, item, onClose, openWhatsApp }) {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="payment-soon-modal">
            <div className="absolute inset-0 bg-espresso/60 backdrop-blur-sm" onClick={onClose} />
            <div className="relative w-full max-w-md bg-white shadow-2xl">
                <button onClick={onClose} className="absolute top-4 right-4 text-neutral-400 hover:text-ink" data-testid="payment-soon-close"><X className="h-5 w-5" /></button>
                <div className="p-9 text-center">
                    <div className="mx-auto h-14 w-14 rounded-full bg-cream border border-[#e0d6c2] grid place-items-center">
                        <Sparkles className="h-6 w-6 text-brand-golddark" />
                    </div>
                    <p className="overline mt-5 mb-2">Payments</p>
                    <h3 className="font-display font-semibold text-2xl">Payment gateway is coming soon</h3>
                    {item?.title && <p className="mt-2 text-sm text-neutral-400">for “{item.title}”</p>}
                    <p className="mt-3 text-neutral-500">Our secure checkout is almost ready. For any queries or to get access right away, connect with the MUVIARTS team on WhatsApp.</p>
                    <button onClick={() => openWhatsApp?.("launch")} className="btn-primary w-full mt-6" data-testid="payment-soon-whatsapp"><MessageCircle className="h-4 w-4" /> Chat on WhatsApp</button>
                    <button onClick={onClose} className="btn-outline w-full mt-3" data-testid="payment-soon-dismiss">Maybe later</button>
                </div>
            </div>
        </div>
    );
}
